import itemEditComponent from './item.edit.component';

let itemEditModule = angular.module('itemedit', [
])

.component('itemedit', itemEditComponent)

.name;

export default itemEditModule;


// WEBPACK FOOTER //
// ./client/app/components/item/edit/index.js